import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3109/consumer/productReview";
};

export const mallLoadProductReviewTag = (productID, params) => {
  const url = `${baseURL()}/getReviewKey/${productID}`;

  return axios.post(url, params);
};

export const mallLoadProductReviewList = (productID, params, reviewID) => {
  const url = `${baseURL()}/getReview/${productID}${
    reviewID !== null ? "/" + reviewID : ""
  }`;

  return axios.post(url, params);
};

export const mallProductReview = (orderID, productID, params) => {
  const url = `${baseURL()}/postReview/${orderID}/${productID}`;
  return axios.post(url, params);
};

export const mallLikedProduct = reviewID => {
  const url = `${baseURL()}/likeReview/${reviewID}`;
  return axios.get(url);
};
